// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Guinea-Bissau */
const GW = /^(?:9(?:5\d|6[569]|77)\d{6})$/;

export default GW;
